import { Component, inject, OnDestroy, OnInit } from "@angular/core";
import { Subject, switchMap } from "rxjs";
import { MarketOpsService } from "../market/market-ops.service";
import { ActivatedRoute } from "@angular/router";
import { MarketComponent } from "../market/market.component";
import { AlertComponent } from "../../../../components/alert/alert.component";
import { BookmakerComponent } from "../bookmaker/bookmaker.component";
import { FancyMarketComponent } from "../fancy-market/fancy-market.component";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "app-single-market-view",
  imports: [MarketComponent, AlertComponent, BookmakerComponent, FancyMarketComponent],
  templateUrl: "./single-market-view.component.html",
  styleUrl: "./single-market-view.component.scss",
})
export class SingleMarketViewComponent implements OnInit, OnDestroy {
  readonly destroy$ = new Subject<void>();
  marketOps = inject(MarketOpsService);
  route = inject(ActivatedRoute);
  market: any = null;

  ngOnInit() {
    this.route.paramMap
      .pipe(
        switchMap((params: any): any => {
          const marketId = params.get("marketId");
          const compareKey = marketId.includes("sb_") ? "topic" : "marketId";
          return marketId ? this.marketOps.getMarket(marketId, compareKey) : null;
        }),
      )
      .pipe(takeUntil(this.destroy$))
      .subscribe((market: any) => {
        // console.log(market);
        this.market = market;
        if (market) this.marketOps.setTopics([`bf_${market?.marketId}`]);
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
